import { API } from '@shared/types/api';
import { i18n } from '@shared/util/i18n';

type TagOption = API.TagComponentOption;

export interface TagOptionsProps {
  options: TagOption[];
  selectedValues: string[];
  onChange: (values: string[]) => void;
  filter: string;
  setFilter: (filter: string) => void;
  canCreate: boolean;
  /** Keeps at least one tag selected: the last one can't be cleared. */
  isRequired?: boolean;
}

export function getSearchPlaceholder(canCreate: boolean) {
  if (canCreate) {
    return i18n('common.searchOrCreate');
  }
  return undefined;
}
